import React from 'react';
import PropTypes from 'prop-types';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '2.75rem',
    height: '2.75rem',
    backgroundColor: '#2a3e40',
    border: 'none',
    borderRadius: '50%',
    transition: 'background-color .2s ease-in-out',
    '& svg': {
      width: '1.375rem',
      height: '1.375rem',
    },
  },
  dark: {
    '& svg': {
      fill: 'white',
    },
    '&:hover': {
      backgroundColor: '#344d50',
    },
  },
  light: {
    border: '1px solid #ddd',
    '& svg': {
      fill: '#202f31',
    },
    '&:hover': {
      backgroundColor: '#eef2f4',
    },
  },
});

export const IconLink = ({ light, ...props }) => {
  const classes = useStyles();
  return (
    <Link
      classes={{ root: clsx(classes.root, light ? classes.light : classes.dark) }}
      underline="none"
      {...props}
    />
  );
};

IconLink.propTypes = {
  light: PropTypes.bool,
};

IconLink.defaultProps = {
  light: false,
};

export default IconLink;
